export const toggleSideMenu = (state) => {
    state.isSideMenuOpen = !state.isSideMenuOpen;
};

export const closeSideMenu = (state) => {
    state.isSideMenuOpen = false;
};